import { render, staticRenderFns } from "./FilterLabel.vue?vue&type=template&id=ac475e6e&scoped=true&"
import script from "./FilterLabel.vue?vue&type=script&lang=js&"
export * from "./FilterLabel.vue?vue&type=script&lang=js&"
import style0 from "./FilterLabel.vue?vue&type=style&index=0&id=ac475e6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac475e6e",
  null
  
)

export default component.exports